import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PhasesSection } from '../components/PhasesSection';
import { AgendaSection } from '../components/AgendaSection';
import { RouteMapSection } from '../components/RouteMapSection';
import { VenueMapSection } from '../components/VenueMapSection';
import { PetWallSection } from '../components/PetWallSection';
import { TicketsSection } from '../components/TicketsSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { ActivitiesSection } from '../components/ActivitiesSection';
import { LocationSection } from '../components/LocationSection';
import { CauseSection } from '../components/CauseSection';
import { ContactSection } from '../components/ContactSection';
import { SponsorsBannerSection } from '../components/SponsorsBannerSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-2505" />
      <ActivitiesSection data-id="element-2506" />
      <AboutSection data-id="element-2507" />
      <TicketsSection data-id="element-2508" />
      <CauseSection data-id="element-2509" />
      <SponsorsBannerSection data-id="element-2510" />
      <SponsorsSection data-id="element-2511" />
      <AgendaSection data-id="element-2512" />
      <RouteMapSection data-id="element-2513" />
      <VenueMapSection data-id="element-2514" />
      <PetWallSection data-id="element-2515" />
      <LocationSection data-id="element-2516" />
      <PhasesSection data-id="element-2517" />
      <ContactSection data-id="element-2518" />
    </>;
}